import { AxiosRequestConfig } from 'axios';
import request from 'src/services/request';
import { directApi } from 'src/services/request';

export interface ICustomTestDocument {
  id: number;
  name: string;
  file_url: string;
  file_type: string;
}

export interface ITestDetails {
  id: number;
  application_id: number;
  state: string;
  title: string;
  description: string;
  time_limit: number;
  time_left: number;
  test_type?: string | null;
  custom_test_docs?: ICustomTestDocument[];
  example_questions: IExampleQuestion[];
  company: {
    name: string;
    logo_url: string | null;
  } | null;
  job: {
    position_title: string;
  } | null;
}

export interface IExampleQuestion {
  id: number;
  text: string;
  answers: IAnswer[];
}

export interface IAnswer {
  id: number;
  text: string;
}

export interface IQuestion {
  id: number;
  text: string;
  answers: IAnswer[];
}

export interface ITestProgress {
  answered: number;
  total: number;
  percentage: number;
}

export interface IStartTestResponse {
  status: string;
  question: IQuestion;
  time_left: number;
  progress: ITestProgress;
  custom_test_docs?: ICustomTestDocument[];
  finish_date?: string;
}

export interface IAnswerResponse {
  status: 'ok' | 'completed';
  is_correct: boolean;
  correct_answer: string;
  next_question?: IQuestion;
  time_left?: number;
  progress?: ITestProgress;
  final_score?: number;
  total_questions?: number;
  answered_questions?: number;
}

export interface IFinishTestResponse {
  status: string;
  state?: string;
  final_score: number;
  total_questions: number;
  answered_questions: number;
}

// export function getTestDetails(testId: number, config?: AxiosRequestConfig) {
//     return request.get<void, ITestDetails>(`/online_tests/${testId}`, config);
// }
export function getTestDetails(testId: number, config?: AxiosRequestConfig) {
  return directApi.get<void, ITestDetails>(`/online_tests/${testId}`, config);
}

export function startTest(testId: number, config?: AxiosRequestConfig) {
  return directApi.get<void, IStartTestResponse>(`/online_tests/${testId}/start`, config);
}

export function submitAnswer(testId: number, questionId: number, answer: string, config?: AxiosRequestConfig) {
  return directApi.post<void, IAnswerResponse>(
    `/online_tests/${testId}/answer`,
    { question_id: questionId, input: answer },
    config,
  );
}

export function finishTest(testId: number, config?: AxiosRequestConfig) {
  return directApi.post<void, IFinishTestResponse>(`/online_tests/${testId}/finish`, {}, config);
}

export function downloadCustomDocument(testId: number, documentId: number) {
  const url = `/online_tests/${testId}/download_document?document_id=${documentId}`;
  window.location.href = url;
}

export function uploadTestFiles(testId: number, files: File[], config?: AxiosRequestConfig) {
  const formData = new FormData();
  files.forEach((file) => {
    formData.append('files[]', file);
  });

  return directApi.post<FormData, any>(`/online_tests/${testId}/upload_responses`, formData, {
    ...config,
    headers: {
      ...config?.headers,
      'Content-Type': 'multipart/form-data',
    },
  });
}

export function validateTest(
  companyId: string | number,
  jobId: string | number,
  applicantId: string | number,
  testId: string | number,
  score: number,
  config?: AxiosRequestConfig,
) {
  return directApi.put<void, any>(
    `/api/v1/companies/${companyId}/jobs/${jobId}/applicants/${applicantId}/tests/${testId}/validate`,
    { score },
    config,
  );
}

export function manualUploadTestFile(
  companyId: string | number,
  jobId: string | number,
  applicantId: string | number,
  testId: string | number,
  file: File,
) {
  const formData = new FormData();
  formData.append('file', file);

  return directApi.put<void, any>(
    `/api/v1/companies/${companyId}/jobs/${jobId}/applicants/${applicantId}/tests/${testId}/manual_upload`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
}
